export const PATIENT_STATUS = {
  NEW: "new",
  RETURNING: "returning",
  COACH: "coach",
} as const;
